import store from 'src/redux/store';

class Authenticated {
  constructor() {
    this.authenticated = false;
    this.memberName = '';
  }

  login(callBack) {
    this.authenticated = true;
    callBack();
  }

  logout(callBack) {
    this.authenticated = false;
    callBack();
  }

  getMemberName() {
    return this.memberName;
  }

  setMemberName(firstName) {
    this.memberName = firstName;
  }

  isAuthenticated() {
    this.authenticated = store.getState().user.isLoggedIn;
    return this.authenticated;
  }
}

export default new Authenticated();
